import { Page } from '@dixa/lib-shared-habla';

import { ProfileDesktopAppLink } from './components/form/components/desktopAppLink/profileDesktopAppLink';
import { ProfileForm } from './components/form/profileForm';
export const SettingsProfileView = (): JSX.Element => {
  return (
    <Page>
      <Page.Head title="Profile" controls={<ProfileDesktopAppLink />} />

      <Page.Body>
        <ProfileForm />
      </Page.Body>
    </Page>
  );
};
